import { getDictPhrase } from "../../helpers";
export const getSubheadingDaysName = (formatDate, date, timeZone, dict) => {
    return {
        name: `${getDictPhrase(dict, `day-${date.getDay()}`)} ${formatDate(date.toISOString(), timeZone)}`
    };
};
//# sourceMappingURL=getSubheadingDaysName.js.map